module.exports = __webpack_public_path__ + "static/directors2-3d5dbdd552c8422a22495361dd6cefd4.jpg";